"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultValue = void 0;
var objects_1 = require("./objects");
var utils_1 = require("./utils");
// https://github.schibsted.io/spt-dataanalytics/event-formats/blob/master/schema/master/common-definitions.json#L295
var originIdRegex = new RegExp('^unknown$|^sdrn:(.*)$');
function isOriginSDRN(originId) {
    return (0, utils_1.isString)(originId) && originIdRegex.test(originId);
}
function origin(input) {
    var _a = input || {}, originInput = _a.origin, provider = _a.provider;
    var _b = originInput || {}, originInputId = _b.id, originInputType = _b.type, rest = __rest(_b, ["id", "type"]);
    var providerId = (provider || {}).id;
    // If the id of origin has already been formatted upstream, we don't want to do it again
    // This can happen, since previously we allowed the id through without any formatting and
    // brands had to do it on their end to get it correctly.
    var formattedOriginId = isOriginSDRN(originInputId)
        ? originInputId
        : (0, objects_1.generateObjectSDRN)(originInputId, providerId, originInputType);
    var base = __assign(__assign({}, (formattedOriginId && { '@id': formattedOriginId })), (originInputType && { '@type': originInputType }));
    return Object.assign({}, base, rest);
}
exports.default = origin;
var defaultValue = function () { return undefined; };
exports.defaultValue = defaultValue;
